// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const manageUsersSelector = createSelector(
    (state): any => state,
    (res: { manageUsers: any }) => res.manageUsers
);

export const usersSelector = createSelector(
    manageUsersSelector,
    res => res.users || []
);

export const soldToShipToSelector = createSelector(
    manageUsersSelector,
    res => res.soldToShipTo || []
);

export const rolesSelector = createSelector(
    manageUsersSelector,
    res => res.roles || []
);

export const channelsSelector = createSelector(
    manageUsersSelector,
    res => res.channels || []
);

export const allTierSelector = createSelector(
    manageUsersSelector,
    res => res.tiers || []
);

export const createUserStatusSelector = createSelector(
    manageUsersSelector,
    res => res.userCreation || { status: undefined }
);

export const deleteUserStatusSelector = createSelector(
    manageUsersSelector,
    res => res.userDeletion || { status: undefined }
);